<template>
  <div id="app">
    <router-view v-if="status.loaded && authenticated"/>
    <loading-spinner v-if="!status.loaded && !authenticated"/>
    <component :is="modalBoxComponent" :args="modalBoxComponentArgs"/>
  </div>
</template>
<script>
  import {loadAuth} from '@/data/api/auth'
  import {retrieveConfig, getVersions, status} from "@/config";
  import LoadingSpinner from "@/components/LoadingSpinner";
  import {mapGetters} from "vuex";
  import {bus} from "@/main";

  export default {
    name: 'App',
    components: {LoadingSpinner},
    data() {
      return {
        status,
        authenticated: false,
        modalBoxComponent: null,
        modalBoxComponentArgs: null,
      }
    },
    computed: {
      ...mapGetters(['userInfo'])
    },
    watch: {
      async userInfo(ui) {
        if (!ui) return
        if (!this.authenticated && ui.userId && ui.sessionId) {
          this.authenticated = true
        }
      }
    },
    async created() {
      const ok = await retrieveConfig()
      this.$store.commit('setVersions', await getVersions())
      if (!ok) {
        this.$toasted.error("Application cannot start. Please contact administrator. Error code CNF001.", {duration: 30000})
        return
      }
      if (this.$route.path === '/auth') {
        this.authenticated = true
      } else {
        loadAuth()
        await this.$store.dispatch('updateUserInfo')
      }

      bus.$on('modalBoxCreate', (data) => {
        this.modalBoxComponent = data.component
        this.modalBoxComponentArgs = data.componentArgs
      })
      bus.$on('modalBoxDestroy', () => {
        this.modalBoxComponent = null
        this.modalBoxComponentArgs = null
      })
    },
  }
</script>
<style>
  @import './assets/mac.css';

  #app {
    height: 100%;
  }
</style>

<style lang="scss">
  @import 'assets/scss/styles.scss';
</style>
